// AUTO-GENERATED from gotra_ep01_wts2.json — first 45.6s of the Charon narration.
// [start_s, end_s, word]
export type W = readonly [number, number, string];
export const WORDS: W[] = [
  [0.30, 0.58, "बच्चे"],
  [0.66, 0.74, "का"],
  [0.84, 1.04, "जन्म"],
  [1.14, 1.22, "हो,"],
  [1.58, 1.96, "मुंडन"],
  [2.04, 2.12, "हो,"],
  [2.40, 2.68, "शादी"],
  [2.78, 2.86, "हो,"],
  [3.28, 3.44, "गृह"],
  [3.54, 3.90, "प्रवेश"],
  [3.94, 4.02, "हो,"],
  [4.26, 4.52, "हवन"],
  [4.58, 4.64, "हो,"],
  [5.02, 5.10, "या"],
  [5.20, 5.42, "किसी"],
  [5.48, 5.72, "अपने"],
  [5.76, 5.84, "का"],
  [5.94, 6.22, "अंतिम"],
  [6.28, 6.76, "संस्कार।"],
  [7.22, 7.38, "हर"],
  [7.45, 7.71, "बार,"],
  [7.99, 8.27, "सबसे"],
  [8.33, 8.59, "पहले,"],
  [8.69, 8.99, "पंडित"],
  [9.07, 9.15, "जी"],
  [9.31, 9.43, "एक"],
  [9.49, 9.57, "ही"],
  [9.63, 9.89, "सवाल"],
  [9.93, 10.23, "पूछते"],
  [10.27, 10.35, "हैं।"],
  [10.69, 11.03, "आपका"],
  [11.13, 11.43, "गोत्र"],
  [11.49, 11.61, "क्या"],
  [11.69, 11.75, "है।"],
  [12.23, 12.35, "और"],
  [12.43, 12.59, "हम"],
  [12.63, 12.79, "में"],
  [12.83, 12.91, "से"],
  [12.91, 13.49, "ज़्यादातर"],
  [13.53, 13.73, "लोग"],
  [13.95, 14.17, "उसी"],
  [14.27, 14.41, "पल"],
  [14.53, 14.71, "घर"],
  [14.79, 14.93, "फ़ोन"],
  [14.95, 15.29, "लगाते"],
  [15.33, 15.43, "हैं।"],
  [15.95, 16.01, "तो"],
  [16.13, 16.39, "आज"],
  [16.47, 16.71, "सीधे"],
  [16.79, 16.97, "काम"],
  [17.03, 17.09, "की"],
  [17.13, 17.37, "बात।"],
  [17.67, 17.97, "गोत्र"],
  [18.09, 18.35, "होता"],
  [18.43, 18.53, "क्या"],
  [18.59, 18.67, "है।"],
  [19.05, 19.17, "और"],
  [19.17, 19.43, "इसके"],
  [19.51, 19.77, "साथ"],
  [19.89, 19.97, "दो"],
  [20.13, 20.33, "शब्द"],
  [20.47, 20.63, "और"],
  [20.71, 20.95, "चलते"],
  [20.99, 21.15, "हैं,"],
  [21.25, 21.59, "प्रवर"],
  [21.59, 21.91, "और"],
  [22.02, 22.39, "सपिंड।"],
  [22.75, 22.91, "ये"],
  [23.00, 23.28, "दोनों"],
  [23.32, 23.44, "क्या"],
  [23.52, 23.60, "हैं,"],
  [23.66, 24.24, "इनका"],
  [24.32, 24.68, "महत्व"],
  [24.74, 24.86, "क्या"],
  [24.92, 25.00, "है,"],
  [25.44, 25.70, "शादी"],
  [25.76, 25.86, "में"],
  [26.00, 26.28, "असल"],
  [26.30, 26.38, "में"],
  [26.48, 26.62, "क्या"],
  [26.70, 27.00, "मिलाया"],
  [27.06, 27.30, "जाता"],
  [27.32, 27.40, "है,"],
  [27.72, 27.88, "और"],
  [27.88, 28.06, "इस"],
  [28.06, 28.32, "सबमें"],
  [28.32, 28.86, "विज्ञान"],
  [28.90, 29.16, "कितना"],
  [29.20, 29.28, "है।"],
  [29.94, 30.22, "सबसे"],
  [30.26, 30.50, "पहले"],
  [30.62, 30.70, "वह"],
  [30.82, 31.08, "बात"],
  [31.18, 31.24, "जो"],
  [31.34, 31.48, "इस"],
  [31.58, 31.80, "पूरे"],
  [31.80, 32.10, "विषय"],
  [32.18, 32.24, "की"],
  [32.36, 32.56, "जड़"],
  [32.58, 32.66, "है।"],
  [33.18, 33.48, "गोत्र"],
  [33.58, 33.74, "एक"],
  [33.84, 34.06, "शब्द"],
  [34.10, 34.18, "है,"],
  [34.48, 34.64, "पर"],
  [34.64, 34.88, "इसके"],
  [34.92, 35.20, "नीचे"],
  [35.32, 35.40, "दो"],
  [35.58, 35.82, "अलग"],
  [35.84, 36.30, "व्यवस्थाएँ"],
  [36.37, 36.59, "चलती"],
  [36.65, 36.80, "हैं।"],
  [37.05, 37.20, "और"],
  [37.30, 37.56, "दोनों"],
  [37.69, 37.97, "असली"],
  [38.05, 38.15, "हैं।"],
  [38.71, 38.97, "पहली"],
  [39.05, 39.43, "व्यवस्था"],
  [39.53, 39.61, "को"],
  [39.79, 40.09, "आर्ष"],
  [40.13, 40.35, "गोत्र"],
  [40.41, 40.67, "कहते"],
  [40.71, 40.79, "हैं।"],
  [41.23, 41.57, "आर्ष"],
  [41.59, 41.81, "यानी"],
  [42.03, 42.31, "रिषि"],
  [42.35, 42.43, "से"],
  [42.43, 42.65, "जुड़ा"],
  [42.71, 42.87, "हुआ।"],
  [43.47, 43.71, "अपने"],
  [43.81, 44.01, "पिता"],
  [44.11, 44.17, "को"],
  [44.21, 44.49, "लीजिए।"],
  [44.79, 44.93, "फिर"],
  [44.93, 45.25, "उनके"],
  [45.33, 45.53, "पिता।"],
];
export const DUR = 45.6;

/** first word index whose text starts with `s` at/after `from` seconds */
export const at = (needle: string, from = 0): number => {
  const i = WORDS.findIndex((w) => w[0] >= from && w[2].replace(/[।,?]/g, '') === needle);
  return i < 0 ? 0 : WORDS[i][0];
};
/** start time of word index i */
export const t = (i: number): number => WORDS[i][0];
/** end time of word index i */
export const te = (i: number): number => WORDS[i][1];
/** joined text of an inclusive index range */
export const phrase = (a: number, b: number): string => WORDS.slice(a, b + 1).map((w) => w[2]).join(' ');

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
